import {
  ArchiveBoxIcon,
  CodeBracketSquareIcon,
  CommandLineIcon,
  DocumentIcon,
  DocumentTextIcon,
  MusicalNoteIcon,
  PhotoIcon,
  TableCellsIcon,
  VideoCameraIcon,
} from "@heroicons/react/24/solid";
import type React from "react";

import { cn } from "@/lib/utils";
import { CodeSolid } from "@/components/icons/code-solid";

export function FileTypeIcon({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  const ext = name.split(".").pop()?.toLowerCase();
  const Icon = (() => {
    switch (ext) {
      case "ts":
      case "tsx":
      case "js":
      case "jsx":
      case "cjs":
      case "mjs":
      case "html":
      case "htm":
      case "css":
      case "scss":
      case "sass":
        return CodeSolid as unknown as React.ComponentType<{
          className?: string;
        }>;
      case "json":
        return CodeBracketSquareIcon;
      case "md":
      case "mdx":
      case "txt":
      case "log":
      case "yml":
      case "yaml":
      case "toml":
      case "ini":
        return DocumentTextIcon;
      case "svg":
      case "png":
      case "jpg":
      case "jpeg":
      case "gif":
      case "webp":
      case "ico":
      case "bmp":
      case "tif":
      case "tiff":
      case "avif":
        return PhotoIcon;
      case "csv":
      case "xlsx":
      case "xls":
        return TableCellsIcon;
      case "sh":
      case "bash":
      case "zsh":
      case "fish":
        return CommandLineIcon;
      case "mp3":
      case "wav":
      case "flac":
        return MusicalNoteIcon;
      case "mp4":
      case "mov":
      case "avi":
      case "mkv":
      case "webm":
        return VideoCameraIcon;
      case "zip":
      case "gz":
      case "tgz":
      case "tar":
      case "rar":
      case "7z":
        return ArchiveBoxIcon;
      default:
        return DocumentIcon;
    }
  })();

  return <Icon aria-hidden className={cn("size-3 shrink-0", className)} />;
}
